/** @format */
import {
    Icon,
    IconSize,
    IconVariant,
} from '@mpb-com/feather/components/atoms/icon';
import { useTranslation } from 'next-i18next';
import React, { FunctionComponent } from 'react';

import RefreshIcon from '@toucan/client/global/icons/refresh.svg';

import { DEFAULT_TEST_ID } from './constants';
import { ProductComparisonItemErrorHeader as StyledProductComparisonItemErrorHeader } from './error-header.styles';
import { ProductComparisonItemErrorProps } from './types';

export const ProductComparisonItemErrorHeader: FunctionComponent<
    ProductComparisonItemErrorProps
> = ({
    'data-testid': dataTestId = DEFAULT_TEST_ID,
    columnIndex,
    onRefetch,
}) => {
    const { t } = useTranslation();

    return (
        <StyledProductComparisonItemErrorHeader
            data-testid={dataTestId}
            $columnIndex={columnIndex}
            $rowIndex={0}
        >
            <p className="product-comparison-item-error-message">
                {t('Refresh to update')}
            </p>
            <Icon
                data-testid={`${dataTestId}__refresh-button`}
                className="product-comparison-item-refresh-button"
                variant={IconVariant.ACTIONABLE}
                size={IconSize.M}
                onClick={onRefetch}
            >
                <RefreshIcon />
            </Icon>
        </StyledProductComparisonItemErrorHeader>
    );
};
